import StepTemplates from "./step_templates.coffee"

$(document).on 'turbolinks:load', ->
  StepTemplates.add_listeners()
